"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDmsMultipleTabsToken = void 0;
var _react = require("react");
var _reactRouterDom = require("react-router-dom");
var _DmsTokenHook = require("../components/DmsTokenHook/DmsTokenHook");
var _TabsEnum = require("../constants/TabsEnum");
/* 
This hook is used to allow exchange of token between tabs
so a new opened tab will have credentials if user already
logged. Also, if user loged out from any tab it will close
the session for all tabs.
*/

const useDmsMultipleTabsToken = (token, setToken) => {
  const navigate = (0, _reactRouterDom.useNavigate)();
  (0, _react.useEffect)(() => {
    // Trigger to listen when changes in tabs
    const triggerRequestingSharedCredentials = () => {
      (0, _DmsTokenHook.credentialsRequest)();
    };
    triggerRequestingSharedCredentials();
    const handleStorageEvent = event => {
      // If exit from one tab, exit from them all
      if (event.key === _TabsEnum.TabsEnum.removeToken) {
        sessionStorage.clear();
        navigate(0);
      }
      // Tab with token will share credentials to new tabs
      else if (event.key === _TabsEnum.TabsEnum.startingTab && token) {
        (0, _DmsTokenHook.credentialsSharing)();
      }
      // New tab will use token from other tabs
      else if (event.key === _TabsEnum.TabsEnum.sharingCredentials && !token && event.newValue) {
        const sharedData = JSON.parse(event.newValue);
        if (sharedData !== null && sharedData !== void 0 && sharedData.refresh_token) {
          setToken(sharedData);
        }
      }
    };

    // Event listener for storage -> check for token when a tab is opened
    window.addEventListener('storage', handleStorageEvent);

    // Clean up on unmount
    return () => {
      window.removeEventListener('storage', handleStorageEvent);
    };
  }, [token, setToken, navigate]);
};
exports.useDmsMultipleTabsToken = useDmsMultipleTabsToken;